import { memo } from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { useConnectionStore } from "stores/ConnectionStore";
import { ActionState } from "stores/lib";
import { useUserStore } from "stores/UserStore";

import Destinations from "external/destinations";

import PossibleIntegration from "./Destination";
import Loading from "./Loading";

// -----------------------------------------------------------------------------

const EnvironmentPossibleDestinations = memo(
  function EnvironmentPossibleDestinations() {
    const [store] = useConnectionStore();
    const [userStore] = useUserStore();

    const possibleDestinations = Destinations.services.filter((s) => {
      if (s.featureFlag) {
        return userStore.user.features & s.featureFlag;
      } else {
        return true;
      }
    });

    //
    switch (true) {
      case store.loadConnections.state === ActionState.IN_PROGRESS:
        return (
          <Grid container spacing={1}>
            <Loading />
          </Grid>
        );

      case possibleDestinations.length > 0:
        return (
          <Grid container spacing={1}>
            {possibleDestinations.map((integration) => {
              return (
                <PossibleIntegration
                  destination={integration as any}
                  hideDismissButton
                  key={integration.name}
                />
              );
            })}
          </Grid>
        );

      default:
        return (
          <Typography variant="body1">
            You&apos;ve connected to all destinations.
          </Typography>
        );
    }
  }
);

export default EnvironmentPossibleDestinations;
